<script setup>
import ThirdPartyLoginButtons from "./ThirdPartyLoginButtons.vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close", "switchToSignIn"]);

const router = useRouter();

// 使用认证模态框 composable 获取跳转地址
const { consumeRedirect } = useAuthModals();

function handleThirdPartySuccess() {
  emit("close");
  // 检查是否有登录后跳转地址
  const redirect = consumeRedirect();
  if (redirect) {
    router.push(redirect);
  }
}

// No email/password fields for signup modal — providers only
</script>

<template>
  <UModal
    v-model:open="props.isOpen"
    @update:open="emit('close')"
    :dismissible="false"
    :ui="{
      content:
        'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100vw-2rem)] max-w-md max-h-[calc(100dvh-2rem)] sm:max-h-[calc(100dvh-4rem)] rounded-lg shadow-lg ring ring-default overflow-hidden',
    }"
  >
    <template #default>
      <span class="hidden"></span>
    </template>

    <template #content>
      <UButton
        color="neutral"
        variant="ghost"
        icon="i-lucide-x"
        aria-label="Close modal"
        @click="emit('close')"
        class="absolute top-4 right-4 z-10"
      />

      <div class="p-4 sm:p-6">
        <UAuthForm title="Create account" icon="i-lucide-user-plus">
          <template #providers>
            <ThirdPartyLoginButtons
              mode="signup"
              @success="handleThirdPartySuccess"
            />
          </template>
          <template #description>
            Already have an account?
            <UButton
              variant="link"
              class="text-[#8A53FC] hover:underline p-0"
              @click="emit('switchToSignIn')"
            >
              Sign In
            </UButton>
          </template>
          <template #submit>
            <!-- No submit button needed for providers-only signup -->
          </template>
          <template #footer>
            <span class="text-xs text-muted-foreground/90">
              By proceeding, you agree to our
              <ULink
                to="https://sharkfoto.com/company/trust/terms/"
                class="text-xs text-muted-foreground/90 hover:underline"
                target="_blank"
                >Terms of Use</ULink
              >
              and
              <ULink
                to="https://sharkfoto.com/company/trust/privacy/"
                class="text-xs text-muted-foreground/90 hover:underline"
                target="_blank"
                >Privacy Policy</ULink
              >.
            </span>
          </template>
        </UAuthForm>
      </div>
    </template>
  </UModal>
</template>
